export const safeAtob = (value: string): string => {
  try {
    return atob(value);
  } catch {
    return "";
  }
};
